import { useLanguage } from "../App";
import { motion } from "framer-motion";

export const Footer = ({ onLegalClick }) => {
  const { t } = useLanguage();

  const legalLinks = [
    { key: "terms", label: t.footer.terms },
    { key: "privacy", label: t.footer.privacy },
    { key: "legal", label: t.footer.legal },
    { key: "cookies", label: t.footer.cookies },
  ];

  return (
    <footer className="bg-slate-900 text-white py-12 px-4" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="flex flex-col items-center text-center"
        >
          {/* Logo */}
          <div className="flex items-center gap-3 mb-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_7fe777d6-9bad-4a97-9808-a97a60a006ea/artifacts/x40hmr43_nuevo%20logo%20documatch.jpg" 
              alt="Documatch" 
              className="h-10 object-contain"
              style={{ background: "transparent" }}
            />
          </div>

          {/* Tagline */}
          <p className="text-slate-400 text-sm mb-6">
            {t.subtitle}
          </p>

          {/* LinkedIn */}
          <a
            href="https://www.linkedin.com/company/documatch-eu/?viewAsMember=true"
            target="_blank"
            rel="noopener noreferrer"
            className="text-slate-400 hover:text-blue-400 transition-colors mb-6"
            data-testid="footer-linkedin"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
            </svg>
          </a>

          {/* Legal Links */}
          <div className="flex flex-wrap justify-center gap-4 mb-6">
            {legalLinks.map((link) => (
              <button
                key={link.key}
                onClick={() => onLegalClick(link.key)}
                className="text-slate-400 hover:text-white text-sm transition-colors"
                data-testid={`footer-${link.key}`}
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* Copyright */}
          <p className="text-slate-500 text-sm">
            {t.footer.copyright}
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
